import { grey } from '@mui/material/colors'
import Typography from '@mui/material/Typography'
import React from 'react'

// Small grey rounded label on the right of an exception-card row — the delay timer,
// the no-access sub-option, or a generic detail value. Long values wrap to new lines
// instead of truncating (serial numbers with notes, free-text damage values).
const ExceptionTailPill: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography
    bgcolor={grey[100]}
    borderRadius={1}
    fontWeight={400}
    p={0.75}
    sx={{ maxWidth: '100%', overflowWrap: 'anywhere' }}
    variant="h6"
  >
    {children}
  </Typography>
)

export default ExceptionTailPill
